import {Component} from '@angular/core';
import {ContactUsComponent} from "./contact-us/contact-us.component";
import {CoverComponent} from "./cover/cover.component";
import {ImrpoveComponent} from "./imrpove/imrpove.component";
import {OurCustomersComponent} from "./our-customers/our-customers.component";
import {OurServicesComponent} from "./our-services/our-services.component";
import {TechnologiesComponent} from "./technologies/technologies.component";
// import {ProjectsComponent} from "./projects/projects.component";
// import {ReviewsComponent} from './reviews/reviews.component';

@Component({
  selector: 'app-homepage',
  imports: [
    ContactUsComponent,
    CoverComponent,
    ImrpoveComponent,
    OurCustomersComponent,
    OurServicesComponent,
    TechnologiesComponent,
    // ProjectsComponent,
    // ReviewsComponent
  ],
  templateUrl: './homepage.component.html',
  styleUrl: './homepage.component.scss'
})
export class HomepageComponent {

}
